import { Component, Input } from '@angular/core';

export type AlTableBadgeVariant =
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'muted';

/**
 * Pill cell for `app-table` — the same extension mechanism `StatusIconComponent`
 * uses on the website table.
 *
 * Kept value-agnostic on purpose: the consuming table decides label and
 * variant, so any table that needs a coloured status pill can use it without
 * a new component.
 *
 *   {
 *     key: 'action',
 *     title: '…',
 *     component: AlTableBadgeComponent,
 *     componentInputs: ({ row }) => ({ label: …, variant: 'danger' }),
 *   }
 */
@Component({
  selector: 'app-table-badge',
  templateUrl: './table-badge.component.html',
  styleUrl: './table-badge.component.scss',
})
export class AlTableBadgeComponent {
  @Input() label = '';
  @Input() variant: AlTableBadgeVariant = 'muted';
  /** Optional hover text — useful when the label is truncated. */
  @Input() tooltip?: string;
}
